module.exports = __webpack_public_path__ + "img/cordial.dbaabe4.webp";